import PagesContainer from "./PagesContainer";

export default PagesContainer;
